module.exports = __webpack_public_path__ + "static/media/logo-biosintex-blanco.4e951b50.png";